export default __webpack_public_path__ + "images/cdad6a8c8383c38caf1e34b3909a7ddf-Logo.svg";